export default __webpack_public_path__ + "static/media/v870-tang-35.17982b09.jpg";